module.exports = __webpack_public_path__ + "static/media/arrow-up-right-from-square.fbf3dfc9.svg";